/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {useState} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {Link} from '@ion/core/src/types/entities';

interface IdentifierResultsType {
  data?: Link[];
  displayedItems?: number;
  maxItems?: number;
};

/**
 * The `useIdentifierResults` returns required state, groups
 * to display groups and length.
 * ...
 *
 * ```typescript
 *   import {useIdentifierResults} from `@ion/dls/src/hooks`;
 *
 *   const {
 *     itemToDisplay,
       setShowDialog,
       itemLength,
       showDialog,
       moreItem
 *   } = useIdentifierResults();
 *
 * ```
 * @returns 
 */
export const useIdentifierResults = ({
  data,
  maxItems = 20,
  displayedItems = 0
}: IdentifierResultsType) => {
  const [showDialog, setShowDialog] = useState(false);
  const maxItemToDisplay            = maxItems;
  const itemToDisplay               = data?.slice?.(displayedItems, maxItemToDisplay);
  const itemLength                  = data?.length - maxItemToDisplay;
  const moreItem                    = translate('admin-devices:grid.moreData', {itemLength});

  return {
    itemToDisplay,
    setShowDialog,
    itemLength,
    showDialog,
    moreItem
  };
};
